import React from "react";
import { TableColumnData } from "../../../types/common";
import { useTimeConverter } from "../../../hooks/hooks";
import { useTranslation } from "react-i18next";
import { TestResultDataObj } from "../../../types/dataSearch";
import { Gender } from "../../../types/common";

/**
 * 검사결과 데이터셋 컬럼 정의(마스터).
 * accessor 값 = 백엔드 컬럼 키(다운로드 columns 파라미터와 동일해야 함).
 * 이 배열이 표시/선택/다운로드 컬럼의 단일 출처.
 */
export function useTestResultColumns() {
  const { t } = useTranslation("dataSearch");
  const { timeConverter } = useTimeConverter();

  const genderText = (g: Gender) =>
    g === Gender.MALE ? t("columns.genderValue.male") : g === Gender.FEMALE ? t("columns.genderValue.female") : "-";

  const numText = (v: number | null | undefined) => (v === null || v === undefined ? "-" : String(v));

  const columns: TableColumnData<TestResultDataObj>[] = [
    {
      accessor: "name",
      header: t("columns.name"),
      getNode: (r: TestResultDataObj) => <span>{r.name ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "userCode",
      header: t("columns.userCode"),
      getNode: (r: TestResultDataObj) => <span>{r.userCode ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "guardianName",
      header: t("columns.guardianName"),
      getNode: (r: TestResultDataObj) => <span>{r.guardianName ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "guardianPhone",
      header: t("columns.guardianPhone"),
      getNode: (r: TestResultDataObj) => <span>{r.guardianPhone ?? "-"}</span>,
      sortable: false,
      width: 160,
    },
    {
      accessor: "birthday",
      header: t("columns.birthday"),
      getNode: (r: TestResultDataObj) => <span>{r.birthday ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "testedAt",
      header: t("columns.testedAt"),
      getNode: (r: TestResultDataObj) => <span>{r.testedAt ? timeConverter.convertToLocalTime(r.testedAt) : "-"}</span>,
      sortable: true,
    },
    {
      accessor: "ageYear",
      header: t("columns.ageYear"),
      getNode: (r: TestResultDataObj) => <span>{numText(r.ageYear)}</span>,
      sortable: true,
    },
    {
      accessor: "ageBand",
      header: t("columns.ageBand"),
      getNode: (r: TestResultDataObj) => <span>{r.ageBand ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "gender",
      header: t("columns.gender"),
      getNode: (r: TestResultDataObj) => <span>{genderText(r.gender)}</span>,
      sortable: false,
    },
    {
      accessor: "state",
      header: t("columns.state"),
      getNode: (r: TestResultDataObj) => <span>{r.state ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "city",
      header: t("columns.city"),
      getNode: (r: TestResultDataObj) => <span>{r.city ?? "-"}</span>,
      sortable: false,
    },
    {
      accessor: "chapter1Score",
      header: t("columns.chapter1Score"),
      getNode: (r: TestResultDataObj) => <span>{numText(r.chapter1Score)}</span>,
      sortable: false,
    },
    {
      accessor: "chapter2Score",
      header: t("columns.chapter2Score"),
      getNode: (r: TestResultDataObj) => <span>{numText(r.chapter2Score)}</span>,
      sortable: false,
    },
    {
      accessor: "chapter3Score",
      header: t("columns.chapter3Score"),
      getNode: (r: TestResultDataObj) => <span>{numText(r.chapter3Score)}</span>,
      sortable: false,
    },
    {
      accessor: "chapter4Score",
      header: t("columns.chapter4Score"),
      getNode: (r: TestResultDataObj) => <span>{numText(r.chapter4Score)}</span>,
      sortable: false,
    },
    {
      accessor: "chapter5Score",
      header: t("columns.chapter5Score"),
      getNode: (r: TestResultDataObj) => <span>{numText(r.chapter5Score)}</span>,
      sortable: false,
    },
  ];

  return { columns };
}
